module.exports = __webpack_public_path__ + "static/conversation-investors-156103a61e4ebdf4ed0fdfe118df585c.png";